export default "__VITE_PUBLIC_ASSET__4428e8df__"